module.exports = __webpack_public_path__ + "static/media/yellow_mark_icon.1b2cd1be.svg";